<s1-input-label [label]="label" [grouped]="labelGrouped">
  <input #inputEl class="{{ inputClass }} form-control" [ngClass]="{'is-invalid' : !checkIsValid() }" type="{{ type }}" [formControl]="control" [readonly]="readonly" (ngModelChange)="onInputChange($event)"/>
</s1-input-label>